module.exports = __webpack_public_path__ + "img/13.3.TP.1cc9abd4.png";